import { JSX } from 'react'

import { IconProps } from '../../icon'

const File: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M31.9231 8H15.5128C13.0185 8 11 10.0185 11 12.5128V35.4872C11 37.9815 13.0185 40 15.5128 40H27.279C28.4769 40 29.6256 39.5241 30.4626 38.6708L35.1067 34.0267C35.96 33.1733 36.4359 32.041 36.4359 30.8431V12.5128C36.4359 10.0185 34.4174 8 31.9231 8ZM13.4615 35.4872V12.5128C13.4615 11.3805 14.3805 10.4615 15.5128 10.4615H31.9231C33.0554 10.4615 33.9744 11.3805 33.9744 12.5128V29.3333H28.641C27.0656 29.3333 25.7692 30.6297 25.7692 32.2051V37.5385H15.5128C14.3805 37.5385 13.4615 36.6195 13.4615 35.4872ZM28.7395 36.9313C28.5918 37.079 28.4113 37.1774 28.2308 37.2595V32.1887C28.2308 31.959 28.4113 31.7785 28.641 31.7785H33.7118C33.6133 31.959 33.5149 32.1395 33.3836 32.2872L28.7395 36.9313Z'
      fill='black'
    />
    <path
      d='M18.7949 20.3077H28.641C29.3138 20.3077 29.8718 19.7497 29.8718 19.0769C29.8718 18.4041 29.3138 17.8462 28.641 17.8462H18.7949C18.122 17.8462 17.5641 18.4041 17.5641 19.0769C17.5641 19.7497 18.122 20.3077 18.7949 20.3077Z'
      fill='black'
    />
    <path
      d='M23.7179 24.4103H18.7949C18.122 24.4103 17.5641 24.9682 17.5641 25.641C17.5641 26.3138 18.122 26.8718 18.7949 26.8718H23.7179C24.3908 26.8718 24.9487 26.3138 24.9487 25.641C24.9487 24.9682 24.3908 24.4103 23.7179 24.4103Z'
      fill='black'
    />
  </svg>
)

export default File
